import React, {FunctionComponent, useCallback, memo} from 'react';
import './MenuNavigation.less';
import {CategoryNavigation} from '../category-navigation/CategoryNavigation';
import {MainCategoryNavigation} from '../main-category-navigation/MainCategoryNavigation';
import Platform from '../../../platform';
import {CategoryId, MainCategoryId} from '../../../helpers/menu.helper.types';

interface MenuNavigationProps {
	mainCategories: any[];
	selectedMainCategory: { click: boolean, id: MainCategoryId };
	isSticky: boolean;
	onMainCategoryClick: (mainCategoryId: MainCategoryId) => void;
	categories: any[];
	selectedCategory: { click: boolean, id: CategoryId };
	onCategoryClick: (categoryId: CategoryId) => void;
}

export const MenuNavigation: FunctionComponent<MenuNavigationProps> = memo(({
		mainCategories,
		selectedMainCategory,
		isSticky,
		onMainCategoryClick,
		categories,
		selectedCategory,
		onCategoryClick,
	}
) => {

	return <div
		className={`menu-navigation ${((isSticky || Platform.isAndroid || Platform.isIOs)) ? 'menu-navigation--sticky' : ''}`}>
		<MainCategoryNavigation
			mainCategories={mainCategories}
			selectedMainCategory={selectedMainCategory}
			onMainCategoryClick={onMainCategoryClick}
		/>
		<CategoryNavigation
			categories={categories}
			selectedCategory={selectedCategory}
			onCategoryClick={onCategoryClick}
		/>
	</div>;
});
